import { useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const contactListEndpoint = ApiEndpoints.contact.contactList;

const tableHeader = ["Date", "Form Type", "Name", "email", "Mobile", "Organisation", "looking for", "Preferred Date", "Location", "Comments", "Source Url", "current url"];
const tbody = ["createdAt", "form_type", "name", "email", "phone", "organisation", "looking_for", "preferred_date", "location", "comments", "source_url", "current_url"];

export default function Contact() {
  const [data, setData] = useState([]);
  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", contactListEndpoint);
      const result = response.contacts || [];

      const formattedData = result.map((item) => {
        let formattedDate = "-";
        if (item.preferred_date) {
          const dateOnly = item.preferred_date.split("T")[0];
          const [year, month, day] = dateOnly.split("-");
          formattedDate = `${day}/${month}/${year}`;
        }
        return {
          ...item,
          preferred_date: formattedDate,
        };
      });

      setData(formattedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);


  const pagename = {
    name: 'Contact Us',
    user: 'Admin',
    innerpage: 'Contact Us'
  }

  const institutionData = data.filter(
    (item) => item.form_type === "institution"
  );

  const individualData = data.filter(
    (item) => item.form_type === "individual"
  );

  const allContactData = [
    ...institutionData,
    ...individualData,
  ];
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section contact-manage-tab">
        <DataTable data={data} tableHeader={tableHeader} tbody={tbody} showAction={false} />
      </div>
    </>
  )
}
